// extracted by mini-css-extract-plugin
export default {"LeaderboardContainer":"Leaderboard_LeaderboardContainer__IX8CG","innerContainer":"Leaderboard_innerContainer__MZr79","boardContainer":"Leaderboard_boardContainer__h-QAu"};